export default {
  bulkMaxSize: 'Bulk Max Size',
  bulkSupport: 'Bulk Support',
  callBackUrl: 'Call BackUrl',
  host: 'Host',
  paymentUrl: 'Payment Url',
  protocol: 'Protocol',
  priority: 'Priority',
  port: 'Port',
  password: 'Password',
  sendNumber: 'Send Number',
  sendUrl: 'Send Url',
  terminalId: 'Terminal Id',
  userName: 'User Name',
  provider: 'Provider',
  gatewayId: 'Gateway ID',
  map: 'Map',
  alopeyk: 'ALOPEYK',
  chapar: 'CHAPAR',
  mahex: 'MAHEX',
  bazargah: 'BAZARGAH',
  tapin: 'TAPIN',
  melat: 'IPG_MELLAT',
  zarinpal: 'IPG_ZARINPAL',
  nasiba: 'IPG_NASIBA',
  baraneh: 'Baraneh',
  mtyn: 'MTYN',
  badpa: 'BADPA',
  gmail: 'GMAIL',
  gama: 'GAMA',
  magfa: 'MAGFA',
  kavenegar: 'KAVENEGAR',
  firebase: 'FIREBASE',
  sendMethod: 'SendMethod',
  externalId: 'external ID',
  sendEmail: 'Send email',
  ecopeyk: 'ecopeyk',
  postex: 'postex',
  post: 'post'
}
